import React from 'react';

const testimonialsData = [
    {
        id: 1,
        name: "Geetha",
        role: "Digital Marketing",
        rating: 5,
        feedback: "I joined Skill Ascent with no Digital Marketing background, but the practical, Social Media Marketing and live ad campaign training gave me real-time experience. Now I’m confidently working as a Digital Marketing Executive with strong online marketing skills.",
        image: "/images/geetha.jpeg",
        initial: "G",
        color: "#3B82F6"
    },
    {
        id: 2,
        name: "Niharika",
        role: "Digital Marketing",
        rating: 5,
        feedback: "Skill Ascent focuses on practical Digital Marketing training with SEO, live projects, mock interviews and professional resume building support. The career-focused training and placement assistance helped me get placed within a few weeks after course completion.",
        image: "/images/niharika.jpeg",
        initial: "N",
        color: "#10B981"
    },
    {
        id: 3,
        name: "Subhash",
        role: "Digital Marketing",
        rating: 5,
        feedback: "Best Digital Marketing training platform to learn SEO, Social Media Marketing and online marketing from basics to advanced with industry-oriented practical training and freelance opportunities.",
        image: "/images/subhash.jpeg",
        initial: "S",
        color: "#F59E0B"
    },
    {
        id: 4,
        name: "Padma P",
        role: "Graphic Designing",
        rating: 5,
        feedback: "I learned Graphic Designing, Photoshop, Illustrator and branding design with practical project training, helping me confidently handle logo design and branding projects.",
        image: "/images/padma.jpeg",
        initial: "P",
        color: "#EF4444"
    },
    {
        id: 5,
        name: "Anusha",
        role: "Graphic Designing",
        rating: 5,
        feedback: "Best Graphic Designing institute for beginners with practical training in social media creatives, branding design and professional visual content creation.",
        image: "/images/anusha.jpeg",
        initial: "A",
        color: "#EC4899"
    },
    {
        id: 6,
        name: "Vishnu",
        role: "Graphic Designing",
        rating: 5,
        feedback: "Skill Ascent helped me build strong Graphic Designing and visual branding skills with portfolio training, creative design projects and professional design experience.",
        image: "/images/vishnu.jpeg",
        initial: "V",
        color: "#8B5CF6"
    }
];

const Testimonials = () => {
    return (
        <section className="gk-testimonials-section" id="testimonials">
            <div className="gk-container">
                <div className="gk-section-header">
                    <span className="gk-subtitle">STUDENT SUCCESS STORIES</span>
                    <h2 className="gk-title">What Our Learners Say</h2>
                    <div className="gk-underline"></div>
                </div>

                <div className="modern-testimonials-grid">
                    {testimonialsData.map((item, index) => (
                        <div className="modern-testimonial-card" style={{ animationDelay: `${index * 0.15}s` }} key={`testimonial-${item.id}`}>
                            <div className="modern-card-top">
                                <div className="modern-user-profile">
                                    {item.image ? (
                                        <div className="modern-user-avatar" style={{ overflow: 'hidden', padding: 0, border: '2px solid ' + item.color }}>
                                            <img src={item.image} alt={item.name} style={{ width: '100%', height: '105%', objectFit: 'cover' }} />
                                        </div>
                                    ) : (
                                        <div className="modern-user-avatar" style={{ backgroundColor: item.color }}>
                                            {item.initial}
                                        </div>
                                    )}
                                    <div className="modern-user-info">
                                        <h4 className="modern-user-name">{item.name}</h4>
                                        <span className="modern-user-role">{item.role}</span>
                                    </div>
                                </div>
                                <div className="modern-quote-icon">
                                    <i className="fas fa-quote-right"></i>
                                </div>
                            </div>

                            <div className="modern-star-rating">
                                {[...Array(item.rating)].map((_, i) => (
                                    <i key={i} className="fas fa-star"></i>
                                ))}
                            </div>

                            <p className="modern-user-feedback">{item.feedback}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
